import { render, staticRenderFns } from "./list-settle.vue?vue&type=template&id=0f0dd27e&scoped=true&"
import script from "./list-settle.vue?vue&type=script&lang=js&"
export * from "./list-settle.vue?vue&type=script&lang=js&"
import style0 from "./list-settle.vue?vue&type=style&index=0&id=0f0dd27e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0dd27e",
  null
  
)

export default component.exports